module.exports = __webpack_public_path__ + "img/bin.4ef65877.svg";